import * as O from 'fp-ts/Option';
import * as OT from 'fp-ts/OptionT';
import * as Rr from 'fp-ts/Reader';
import * as RrT from 'fp-ts/ReaderT';
import { flow, pipe } from 'fp-ts/function';
export var empty = function () { return O.none; };
export var zero = OT.zero(Rr.Pointed);
export var of = RrT.of(O.Pointed);
export var map = RrT.map(O.Functor);
export var chain = RrT.chain(O.Chain);
export var chainW = RrT.chain(O.Chain);
export var chainReader = flow(Rr.map(Rr.map(O.some)), chain);
export var chainReaderW = flow(Rr.map(Rr.map(O.some)), chainW);
export var chainOptionK = OT.chainOptionK(Rr.Monad);
export var ap = OT.ap(Rr.Applicative);
export var alt = OT.alt(Rr.Monad);
export var altW = OT.alt(Rr.Monad);
export var getOrElseW = function (onNone) {
    return Rr.map(O.getOrElseW(onNone));
};
export var getOrElse = function (onNone) { return getOrElseW(onNone); };
export var getOrElseReader = OT.getOrElse(Rr.Monad);
export var getOrElseReaderW = OT.getOrElse(Rr.Monad);
export var match = OT.match(Rr.Monad);
export var matchW = OT.match(Rr.Monad);
/**
 * Concatinates ReaderOptions via `RO.alt`. Effectively first `Some` wins.
 *
 * @example
 * ```ts
 * pipe(
 *   [RO.empty, RO.of(1), RO.of(2)],
 *   M.concatAll(RO.getMonoidAlt())
 * )
 * // => () => O.some(1)
 * ```
 */
export var getMonoidAlt = function () { return ({
    empty: function () { return O.none; },
    concat: function (a, b) {
        return pipe(a, alt(function () { return b; }));
    }
}); };
